export const logger = {
  log: (...args: unknown[]) => {
    if (window.location.search.includes('debug=true')) {
      console.log('[DEBUG]', ...args);
    }
  },
  warn: (...args: unknown[]) => {
    if (window.location.search.includes('debug=true')) {
      console.warn('[DEBUG]', ...args);
    }
  },
  error: (...args: unknown[]) => {
    if (window.location.search.includes('debug=true')) {
      console.error('[DEBUG]', ...args);
    }
  },
  info: (...args: unknown[]) => {
    if (window.location.search.includes('debug=true')) {
      console.info('[DEBUG]', ...args);
    }
  },
};
